import React, { useState, useEffect } from 'react';
import { Box, Typography, TextField, Button, Snackbar } from '@mui/material';
import { getFileServerConfig, updateFileServerConfig } from '../services/api';

const FileServerConfigPage = () => {
  const [config, setConfig] = useState({ url: '', username: '', password: '' });
  const [snackbar, setSnackbar] = useState({ open: false, message: '' });

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await getFileServerConfig();
        setConfig(response.data);
      } catch (error) {
        console.error('Error fetching file server config:', error);
        setSnackbar({ open: true, message: 'Failed to load configuration' });
      }
    };

    fetchConfig();
  }, []);

  const handleChange = (event) => {
    setConfig({ ...config, [event.target.name]: event.target.value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await updateFileServerConfig(config);
      setSnackbar({ open: true, message: 'Configuration saved successfully' });
    } catch (error) {
      console.error('Error saving file server config:', error);
      setSnackbar({ open: true, message: 'Failed to save configuration' });
    }
  };

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>File Server Configuration</Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          margin="normal"
          name="url"
          label="File Server URL"
          value={config.url}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          margin="normal"
          name="username"
          label="Username"
          value={config.username}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          margin="normal"
          name="password"
          label="Password"
          type="password"
          value={config.password}
          onChange={handleChange}
        />
        <Button type="submit" variant="contained" color="primary" sx={{ mt: 2 }}>
          Save Configuration
        </Button>
      </form>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        message={snackbar.message}
      />
    </Box>
  );
};

export default FileServerConfigPage;